/**
 * TutorCompleteProfileScreen — « Compléter mon profil » (route `tutor/complete-profile`, la ligne
 * « Profil » des paramètres, la tâche de l'accueil, le lien du mail).
 *
 * Un fil : l'état de l'écran, le view-model sur cet état, la lecture de la semaine de « Ma dispo »
 * (`useTutorAvailabilityData`, le crochet du lot dispo), les gestes et l'écriture
 * (`useTutorCompleteProfileState`), la page du DS avec, à l'étape des créneaux, l'éditeur de « Ma
 * dispo » et sa boîte.
 */
import React, { useReducer } from "react"
import { useSelector } from "react-redux"

import {
    TutorAvailabilityDialog,
    TutorCompleteProfilePage,
    TutorWeekEditor,
} from "../../../../../../design-system/tutor"
import { tutorCompleteProfileViewModel } from "../../../../view-models/tutor/Account/tutorCompleteProfileViewModel"
import { useTutorAvailabilityData } from "../Availability/useTutorAvailabilityData"
import { initialTutorCompleteProfileUiState, tutorCompleteProfileUiReducer } from "./tutorCompleteProfileUiState"
import { useTutorCompleteProfileState } from "./useTutorCompleteProfileState"

export function TutorCompleteProfileScreen() {
    const [ui, dispatchUi] = useReducer(tutorCompleteProfileUiReducer, initialTutorCompleteProfileUiState)
    const vm = useSelector((state: unknown) =>
        tutorCompleteProfileViewModel(state, {
            edits: ui.edits,
            openSlots: ui.openSlots,
            startingDate: ui.startingDate,
        })
    )
    const { retry } = useTutorAvailabilityData(() => dispatchUi({ type: "RESEED" }))
    const { dialog, onPressHour, onPickStartingDate, ...gestures } = useTutorCompleteProfileState(
        vm,
        ui,
        dispatchUi,
        retry
    )

    const availabilityEditor =
        vm.week == null ? null : (
            <TutorWeekEditor
                week={vm.week}
                startingDateOpensOn={vm.startingDateOpensOn}
                onPickStartingDate={onPickStartingDate}
                onPressHour={onPressHour}
            />
        )

    return (
        <>
            <TutorCompleteProfilePage
                step={ui.step}
                draft={vm.draft}
                catalogs={vm.catalogs}
                approvedClasses={vm.approvedClasses}
                preview={vm.preview}
                availabilityEditor={availabilityEditor}
                availabilityStatus={vm.week != null ? "ready" : vm.weekLoadFailed ? "failed" : "loading"}
                onRetryAvailability={retry}
                availabilityAdvice={vm.availabilityAdvice}
                errors={ui.errors}
                submitError={ui.submitError}
                loading={vm.loading}
                {...gestures}
                testID="tutor-complete-profile"
            />
            {dialog != null && <TutorAvailabilityDialog {...dialog} />}
        </>
    )
}
